export default function MySQL_SUBSTR() {
  return (
    <div>
      <h2>MySQL_SUBSTR</h2>    </div>
  );
}